import { Link } from "react-router-dom";
import { Icon } from 'semantic-ui-react'

import { authProvider } from "../../auth";
import { PATHS } from "../../paths";

import styles from './Navigation.module.css';

function NavigationItem({ path, iconName, label }: { path: string, iconName: any, label: string }) {
  return (
    <Link to={path} className={styles.link}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Icon name={iconName} className={styles.icon} />
            <div>
                {label}
            </div>
        </div>
    </Link>
  );

}

function MobileNavigationFooter() {
  if (!authProvider.isAuthenticated()) {
      return null;
  }

  return (
    <div className={styles.container}>
        <NavigationItem path={PATHS.CLASSES} iconName='group' label='Classes' />
        <NavigationItem path={PATHS.PEOPLE} iconName='user' label='People' />
        <NavigationItem path={PATHS.ALL_RECORDS} iconName='folder open' label='Records' />
        <NavigationItem path={PATHS.LOGOUT} iconName='log out' label='Logout' />
    </div>
  );
}


export { MobileNavigationFooter };
